import React from 'react';
import { MaterialSelectorProps } from '../interfaces';
import MaterialOptionsList from './MaterialOptionsList';
import MaterialSelectorLabel from './MaterialSelectorLabel';
import { useMaterialSelection } from './useMaterialSelection';
import { useMaterialSelectorData } from './useMaterialSelectorData';
import './materialSelector.scss';

const MaterialSelector: React.FC<MaterialSelectorProps> = (props) => {
  const {
    userId,
    cartItem,
    isCartPage,
    isProductDetailPage,
    materialPrices,
    selectedMaterial,
  } = useMaterialSelectorData(props);
  const handleSelect = useMaterialSelection({
    selectedMaterial,
    cartItem,
    isCartPage,
    isProductDetailPage,
    itemId: props.itemId,
    productId: props.productId,
    userId,
    onSelect: props.onSelect,
  });

  return (
    <div className="space-y-2">
      <MaterialSelectorLabel
        selectedMaterial={selectedMaterial}
        visible={isProductDetailPage || isCartPage}
      />
      <MaterialOptionsList
        materialPrices={materialPrices}
        selectedMaterial={selectedMaterial}
        cartItem={cartItem}
        productId={props.productId}
        itemId={props.itemId}
        onSelect={handleSelect}
      />
    </div>
  );
};

export default MaterialSelector;
